<script setup lang="ts">
defineProps<{
  title: string;
  description: string;
  icon: string;
}>();
defineEmits<{
  (e: "click"): void;
}>();
</script>

<template>
  <button
    type="button"
    class="rounded option-btn w-100"
    @click="$emit('click')"
  >
    <div class="w-100 d-flex justify-content-between align-items-center gap-2">
      <div class="col d-flex flex-column text-start">
        <div class="text-truncate text-white">{{ title }}</div>
        <div class="text-grey" style="line-height: 15px !important">
          <small> {{ description }}</small>
        </div>
      </div>

      <el-icon size="1.5rem">
        <i
          :class="`bi-${icon}`"
          style="transition: transform 0.2s ease-in-out"
        ></i>
      </el-icon>
    </div>
  </button>
</template>

<style lang="scss" scoped></style>
